import { React, useState, useRef } from 'react';

import './index.less';
import SocialShare from '../SocialShare';
import { Button, Tooltip } from 'antd';
import { ShareAltOutlined } from '@ant-design/icons';
import { t } from '../../../languages';

const TIME_OUT = 300;

const ActionButtons = ({ lang, nlikes }) => {
    const [liked, setLiked] = useState(false);
    const timeoutRef = useRef(null);
    const [showShare, setShowShare] = useState(false);

    const handleLikeClick = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        const newLikedState = !liked;
        setLiked(newLikedState);

        timeoutRef.current = setTimeout(() => {
            // callback_heart(newLikedState);
            console.log('Callback heart:', newLikedState);

        }, TIME_OUT);
    };

    const handleDoubleClick = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        if (liked) {
            setLiked(false);
            // callback_heart(false);
        }
    };

    const handleShare = () => {
        // setShowShare(!showShare);

        const shareUrl = 'https://misoroban.com/products/app-abaco-japones-soroban/';

        const data = {
            title: document.title,
            text: 'La app para obtener el poder del ábaco japonés. Activa tu capacidad mental, diviértete con las matemáticas, gana en concentración, atención y razonamiento.',
            url: shareUrl,
        }

        window.navigator.share(data);

    };


    return (
        <section className='action-buttons'>
            <ul>
                {/* <li onClick={handleLikeClick} >
                    {liked ? <img src="./static/action-buttons/heart_red.svg" alt="" /> : <img src="./static/action-buttons/heart.svg" alt="" />}<span className='countn'>{nlikes || null}</span>
                </li>
                <li onClick={handleShare}>
                    <Tooltip placement="bottom" title={<SocialShare lang={lang} />} open={showShare} onOpenChange={setShowShare} color='#fff'>
                        <img src="./static/action-buttons/send.svg" alt="" />
                    </Tooltip>
                </li> */}
                <li onClick={handleLikeClick} >
                    <h3 className="my-data-data">{t(lang, 'sharemis')}:</h3>
                    <SocialShare lang={lang} />
                </li>
                
            </ul>

        </section>
    );
};

export default ActionButtons;